export const UPDATE_COMMIT_FUND             = "UPDATE_COMMIT_FUND";
export const UPDATE_CLAIM_REMAINING_FUND    = "UPDATE_CLAIM_REMAINING_FUND";
export const UPDATE_REFUND_IDO              = "UPDATE_REFUND_IDO";
export const UPDATE_CLAIM_IDO               = "UPDATE_CLAIM_IDO";
export const GET_SIGNATURE_COMMIT           = "GET_SIGNATURE_COMMIT";
export const GET_SIGNATURE_REMAINING_FUND   = "GET_SIGNATURE_REMAINING_FUND";
export const GET_SIGNATURE_REFUND           = "GET_SIGNATURE_REFUND";
export const GET_SIGNATURE_ESPECIAL_REFUND  = "GET_SIGNATURE_ESPECIAL_REFUND";
export const GET_WHITELIST_BY_ADDRESS       = "GET_WHITELIST_BY_ADDRESS";
export const UPDATE_REFUND_ESPECIAL         = "UPDATE_REFUND_ESPECIAL";